
import '@/styles/base.scss'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import App from './App.vue';
import '@jennifersoft/vue-components-v2/style.css';

export default App;


// Auto Vue Mount Plugin에 의해 자동 생성된 초기화 코드

// 마운트 엘리먼트의 data-* 속성을 props로 변환
const mountElement = document.querySelector('#app-v2')
const props = {}

if (mountElement?.dataset) {
  for (const [key, value] of Object.entries(mountElement.dataset)) {
    if (value === 'true') {
      props[key] = true
    } else if (value === 'false') {
      props[key] = false
    } else if (value.trim() === '') {
      props[key] = value
    } else {
      props[key] = isNaN(Number(value)) ? value : Number(value)
    }
  }
}

const app = createApp(App, props)

// Pinia 스토어 초기화
const pinia = createPinia()
const initState = window.__PINIA_INITIAL_STATE__

if (initState) {
  pinia.state.value = {
    server: {
      locale: initState.locale,
      platform: initState.platform,
      permission: initState.permission,
      utcOffset: initState.utcOffset,
      xviewRangeTimeOnDashboard: initState.xviewRangeTimeOnDashboard,
      useAgentTimeForXAxisOnXView: initState.useAgentTimeForXAxisOnXView,
      xviewCacheMinTimeByDomain: initState.xviewCacheMinTimeByDomain,
      tokenWhenUseJenniferFront: initState.tokenWhenUseJenniferFront,
      jenniferChat: initState.jenniferChat,
      jenniferChatOrgId: initState.jenniferChatOrgId,
      jenniferK8s: initState.jenniferK8s,
      defaultRuntimelineMerge: initState.defaultRuntimelineMerge,
      reportTalkOnlyAllowPost: initState.reportTalkOnlyAllowPost,
      enableAi: initState.enableAi,
      namingAlign: initState.namingAlign,
      renderingLevelDashboard: initState.renderingLevelDashboard,
    },
    user: {
      language: initState.language,
      userId: initState.userId,
      groupId: initState.groupId,
      theme: initState.theme,
      uniqueAccessUrl: initState.uniqueAccessUrl,
      expandedDashboardTargetCount: initState.expandedDashboardTargetCount,
    },
    domain: {
      useDomainGroup: initState.useDomainGroup,
      domainJson: initState.domainJson?.domainList?.data ?? [],
      domainListJson: initState.domainListJson?.domainList?.data ?? [],
      domainGroupJson: initState.domainGroupJson?.domainGroupList?.data ?? [],
    },
    meta: {
      currentTimeMillis: initState.currentTimeMillis,
      menuName: initState.menuName,
      activeServiceRange: initState.activeServiceRange,
      domainCount: initState.domainCount,
    }
  }
}

// 사용자 언어 결정
const userLanguage = pinia.state.value?.user?.language || 'ko'

// 해당 언어의 메시지만 동적으로 로드
const loadMessages = async (locale) => {
  try {
    const messages = await import(`@/locales/${locale}.json`)
    return messages.default || messages
  } catch (error) {
    console.warn(`Failed to load locale ${locale}, falling back to ko`)
    const fallbackMessages = await import('@/locales/ko.json')
    return fallbackMessages.default || fallbackMessages
  }
}

// i18n 비동기 초기화
const initApp = async () => {
  // 메시지 로드 (base.scss에서 폰트와 스타일이 이미 로드됨)
  const messages = await loadMessages(userLanguage)
  
  const i18n = createI18n({
    legacy: false,
    locale: userLanguage,
    fallbackLocale: 'ko',
    messages: {
      [userLanguage]: messages
    }
  })
  
  app.use(pinia)
  app.use(i18n)
  app.mount('#app-v2')
}

initApp()
